<template>
  <div>
    <LayoutHead v-if="!isEmbedded"/>
    <ContentBlackWeekBanner v-if="isBlackweek" />
    <main >
      <BasicBtErrorBoundary>
        <slot />
      </BasicBtErrorBoundary>
    </main>
    <LayoutFooter v-if="!isEmbedded"/>
  </div>
</template>
<script setup lang="ts">
  const isBlackweek = 'blackweek' == useAttrs().theme;
  const isEmbedded = useEmbedded();
</script>